import { api } from './api';

export interface InstallAttestmentCopyItem {
  title: string;
  body: string;
}

export interface InstallAttestmentCopyEntry {
  title: string;
  body?: string;
  permitOptions?: Record<string, InstallAttestmentCopyItem>;
}

export interface InstallAttestationCopyResponse {
  version: string;
  items: Record<string, InstallAttestmentCopyEntry>;
}

const installAttestationCopyApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInstallAttestationCopy: build.query<InstallAttestationCopyResponse, { program: string }>({
      query: ({ program }) => ({
        url: `v2/install-attestation-copy`,
        params: { program },
      }),
    }),
  }),
});

export const { useGetInstallAttestationCopyQuery } = installAttestationCopyApi;
